import localStorageTemplates from 'common/local-storage-templates';

export default error => {
  let errMsg = error && error.response && error.response.data && error.response.data.errorMsg;
  let message = error && error.response && error.response.data && error.response.data.message;

  if (errMsg === undefined || errMsg.length <= 0) {
    if (message && message.length > 0) {
      errMsg = message;
    } else {
      errMsg = 'Something went wrong. Please try again.';
    }
  } else if (errMsg === 'offline') {
    if (localStorage.getItem(localStorageTemplates.insentNetworkStatus) === 'offline')
      errMsg = 'noError';
    else errMsg = 'No internet Connection';
  }

  return errMsg;
};
